import { ReactNode } from 'react';
import { Checkbox, Fieldset, ValidationMessage } from '@digdir/designsystemet-react';
import type { RoleInfo } from '../../../../utils/RolesUtils';
import classes from '../Users.module.css';

type RoleChoicesProps = {
  idPrefix: string;
  legend: string;
  description: string;
  roles: RoleInfo[];
  selected: string[];
  disabled?: boolean;
  /** Roller som ikke kan velges bort, med forklaringen som vises under */
  lockedReason?: (role: RoleInfo) => string | undefined;
  error?: string;
  onToggle: (roleKey: string) => void;
  children?: ReactNode;
};

/** Roller som avkrysningsbokser på kort med beskrivelse */
export const RoleChoices = ({
  idPrefix,
  legend,
  description,
  roles,
  selected,
  disabled = false,
  lockedReason,
  error,
  onToggle,
  children,
}: RoleChoicesProps) => (
  <Fieldset className={classes.roles} aria-invalid={error ? true : undefined}>
    <Fieldset.Legend className={classes.rolesLegend}>{legend}</Fieldset.Legend>
    <Fieldset.Description>{description}</Fieldset.Description>
    {roles.map((role) => {
      const checked = selected.includes(role.key);
      const locked = lockedReason?.(role);
      return (
        <div key={role.key} className={classes.roleOption} data-checked={checked}>
          <Checkbox
            id={`${idPrefix}-${role.key}`}
            label={role.label}
            description={locked ? `${role.description} ${locked}` : role.description}
            checked={checked}
            disabled={disabled || Boolean(locked)}
            onChange={() => onToggle(role.key)}
          />
        </div>
      );
    })}
    {error && <ValidationMessage>{error}</ValidationMessage>}
    {children}
  </Fieldset>
);
